import axios from 'axios';

import actions from '../constants';
import { processProfileData } from './profile_helpers';

export const updateProfile = function(csrfToken, contact) {
  return function(dispatch, getState) {
    dispatch(onProfileSaving());

    const { profile, contactId } = getState().profile;
    let profileData = { ...processProfileData(profile, contact), onboarding_status: 'passed' };
    let url = '/contacts/' + contactId;

    sendUpdatedProfileData(dispatch, url, csrfToken, profileData);
  };
}

export const updateOnboardingStatus = function(csrfToken) {
  return function(dispatch, getState) {
    const { contactId } = getState().profile;
    let url = '/contacts/' + contactId;

    sendUpdatedProfileData(dispatch, url, csrfToken, { onboarding_status: 'skipped' });
  };
}

const sendUpdatedProfileData = (dispatch, url, csrfToken, profileData) => {
  return axios.put(url, {
      contact: profileData
    },{
      headers: {
        'X-CSRF-Token': csrfToken
      }
  })
  .then(function(response) {
    dispatch(onProfileSaved());
  })
  .catch(function(response) {
    dispatch(onProfileSaveError(response.data.error.message, response.data.error.errors));
  });
}


export const initializeProfile = function(contact) {
  return {
    type: actions.INITIALIZE_PROFILE,
    contact: contact
  };
}

export const onProfileChange = function(key, value) {
  return {
    type: actions.PROFILE_CHANGE,
    key: key,
    value: value
  };
}

export const onProfileSaving = function() {
  return { type: actions.PROFILE_SAVING };
}

export const onProfileSaved = function() {
  return { type: actions.PROFILE_SAVED };
}

export const onProfileUnsaved = function() {
  return { type: actions.PROFILE_UNSAVED };
}

export const onProfileSaveError = function(errorMsg = "", errors = {}) {
  return {
    type: actions.PROFILE_SAVE_ERROR,
    error: {
      message: errorMsg,
      errors: errors
    }
  };
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/actions/profile.js